/*
* @Author: Joana Oliveira
* @Date:   2022-02-25 10:43:06
* @Last Modified by:   Joana Oliveira
* @Last Modified time: 2022-02-25 10:48:12
*/

jQuery(document).ready(function($) {

	jQuery('.fakeButton__container .btn').click(function(){
		jQuery(this).parents('.acf-form').submit();
	});

});